/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================
 
 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)
 
 Coded by www.creative-tim.com
 
 =========================================================
 
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

import React, { useState } from "react";
import PropTypes from "prop-types";
import Swal from "sweetalert2";
import { CircularProgress, Icon, Tooltip, Card } from "@mui/material";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDSelect from "components/MDSelect";
import DataTable from "examples/Tables/DataTable";

import ComponentsPrivatization, {
  removeColumns,
} from "config/component_privatization";
import { REGISTROS_URL } from "config/bases_url";
import { style_icon } from "helpers/global_vars";
import { useRedirectForm } from "hooks/useRedirectForm";
import usePagination from "hooks/usePagination";
import { COORDINADOR_DOCENTE, RECURSOS_HUMANOS } from "roles";
import { useDeleteUserMutation, useGetPlantillaQuery } from "services";

import RegistroShow from "./registroShow";
import NewPlantilla from "../../ModalCreate/NewPlantilla/newPlantilla";
import useModalHandler from "hooks/useModalHandler";

const FiltersComponentContrato = ({ value, onChange }) => {
  return (
    <MDBox
      display="flex"
      flexDirection={{ xs: "column", lg: "row" }}
      alignItems="center"
      gap={2}
      width="100%"
      mb={5}
    >
      <MDBox sx={{ minWidth: "10rem", width: "30%" }}>
        <MDSelect
          label="Contrato"
          options={[
            { value: "", label: "Limpiar" },
            { value: "false", label: "Administrativo" },
            { value: "true", label: "Docente" },
          ]}
          value={value}
          onChange={onChange}
        />
      </MDBox>
    </MDBox>
  );
};

function DataTableRegistros({ tableHeader }) {
  const [contratoState, setContratoState] = useState("");
  const handleChangeContrato = (val) => setContratoState(val);

  const {
    open: openPlantillaModal,
    handleOpen: handleOpenPlantillaModal,
    handleClose: handleClosePlantillaModal,
  } = useModalHandler();

  const [plantillaIdToEdit, setPlantillaIdToEdit] = useState(null);

  const {
    offset,
    setOffset,
    busqueda,
    setBusqueda,
    limit,
    handleNext,
    handlePrevious,
  } = usePagination();

  const entidad = JSON.parse(sessionStorage.getItem("user")).perfil.entidad.id;

  const {
    data: registros,
    isLoading: isLoadingG,
    isError: isErrorG,
    error: errorG,
  } = useGetPlantillaQuery(
    {
      filter_params: {
        limit: limit,
        offset: offset,
        buscar: busqueda,
        entidad: entidad,
        estudiantes: "false",
        profesores: contratoState,
        query:
          "{id,url,email,first_name,apellido_paterno,apellido_materno,perfil,foto,groups{id,name,url}}",
      },
      shape: {
        id: "id",
        url: "url",
        nombre: "first_name",
        apellido_paterno: "apellido_paterno",
        apellido_materno: "apellido_materno",
        email: "email",
        groups: "groups[].id",
        roles: "groups[].name",
        resourcetype: "perfil.resourcetype[].resourcetype",
        resourcetypeFull: "perfil.resourcetype",
        telefonos: "perfil.telefonos",
        foto: "foto",
      },
    },
    {
      refetchOnReconnect: true,
    },
  );

  //constantes para manejar la paginacion
  const dataProf = registros?.results ? registros.results : registros;
  const countTotal = registros?.count;
  const previous = registros?.previous;
  const next = registros?.next;

  const [
    deleteProfesor,
    {
      isSuccess: isSuccessD,
      isLoading: isLoadingD,
      isError: isErrorD,
      error: errorD,
    },
  ] = useDeleteUserMutation();

  const dataTable = {
    columns: [
      {
        Header: "Apellido Paterno",
        accessor: "apellido_paterno",
        Cell: ({ value }) => {
          return value ? value : "-------------";
        },
      },
      {
        Header: "Apellido Materno",
        accessor: "apellido_materno",
        Cell: ({ value }) => {
          return value ? value : "-------------";
        },
      },
      {
        Header: "Nombre",
        accessor: "nombre",
        Cell: ({ value }) => {
          return value ? value : "-------------";
        },
      },
      {
        Header: "Correo",
        accessor: "email",
        Cell: ({ value }) => {
          return value ? value : "-------------";
        },
      },
      {
        Header: "Rol",
        accessor: "roles",
        Cell: ({ value }) => {
          return value.length !== 0 ? value.join(", ") : "**NO POSEE**";
        },
      },
      {
        Header: "Contrato",
        accessor: "resourcetype",
        Cell: ({ value }) => value.join(", "),
      },
      {
        Header: "Acciones",
        accessor: "actions",
        width: "1%",
        Cell: ({ row: { original } }) => {
          return (
            <MDBox display="flex">
              <ComponentsPrivatization permitted={COORDINADOR_DOCENTE}>
                <MDBox px={0.2}>
                  <Tooltip
                    placement="top"
                    title="Editar la información del usuario"
                  >
                    <Icon
                      style={style_icon}
                      onClick={() =>
                        handleClickEdit(
                          original.resourcetypeFull.find(
                            (el) => el.resourcetype === "Registro",
                          ).id,
                        )
                      }
                      fontSize="small"
                    >
                      edit
                    </Icon>
                  </Tooltip>
                </MDBox>
                {/*<MDBox px={0.2}>*/}
                {/*  <Tooltip*/}
                {/*    placement="top"*/}
                {/*    title="Cambiar rol/es dentro del sistema usuario en cuestión"*/}
                {/*  >*/}
                {/*    <Icon*/}
                {/*      style={style_icon}*/}
                {/*      onClick={() => handleAsignarRol(original)}*/}
                {/*      fontSize="small"*/}
                {/*    >*/}
                {/*      badge*/}
                {/*    </Icon>*/}
                {/*  </Tooltip>*/}
                {/*</MDBox>*/}
                <MDBox px={0.2}>
                  <Tooltip
                    placement="top"
                    title="Eliminar el registro del usuario"
                  >
                    <Icon
                      style={style_icon}
                      onClick={() => handleClickErase(original)}
                      fontSize="small"
                    >
                      remove_circle
                    </Icon>
                  </Tooltip>
                </MDBox>
              </ComponentsPrivatization>
            </MDBox>
          );
        },
      },
    ],
    rows: dataProf ?? [],
  };
  useRedirectForm(
    isLoadingG,
    null,
    isErrorG,
    errorG,
    "Hubo problemas para cargar la información",
    REGISTROS_URL,
  );

  useRedirectForm(
    isLoadingD,
    isSuccessD,
    isErrorD,
    errorD,
    "Profesor eliminado",
    REGISTROS_URL,
  );

  const handleClickErase = (original) => {
    Swal.fire({
      title: "¿Estás seguro?",
      text: `¡Si eliminas el usuario de la plantilla: "${original.nombre} ${original.apellido_materno} ${original.apellido_paterno}", esta acción no se podrá revertir!`,
      icon: "warning",
      reverseButtons: true,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Cancelar",
      confirmButtonText: "Eliminar",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteProfesor(
          original.resourcetypeFull.find((el) => el.resourcetype === "Registro")
            .id,
        );
      }
    });
  };

  // const handleAsignarRol = (e) => {
  //   setId(e.resourcetypeFull.find((el) => el.resourcetype === "Registro").id);
  //   setGroups(e.groups);
  //   handleOpenAsignarRol();
  // };

  const handleClickEdit = (id) => {
    setPlantillaIdToEdit(id);
    handleOpenPlantillaModal();
  };

  const actions = (
    <MDBox display="flex" gap={2} alignItems="center">
      {openPlantillaModal && (
        <NewPlantilla
          open={openPlantillaModal}
          handleClose={() => {
            handleClosePlantillaModal();
            setPlantillaIdToEdit(null);
          }}
          id={plantillaIdToEdit}
        />
      )}

      <ComponentsPrivatization
        permitted={[COORDINADOR_DOCENTE, RECURSOS_HUMANOS]}
      >
        <Tooltip
          placement="top"
          title="Crear nuevo profesor con toda su información requerida"
        >
          <MDButton
            variant="contained"
            color="accent"
            size="medium"
            onClick={() => {
              setPlantillaIdToEdit(null);
              handleOpenPlantillaModal();
            }}
          >
            nuevo
          </MDButton>
        </Tooltip>
      </ComponentsPrivatization>
    </MDBox>
  );

  return (
    <MDBox pt={0} pb={3}>
      <MDBox display="flex" justifyContent={"center"} alignItems={"center"}>
        {isLoadingG ? (
          <CircularProgress sx={{ marginBottom: "3rem" }} color="inherit" />
        ) : (
          <DataTable
            tableHeader={tableHeader}
            actions={actions}
            table={removeColumns(
              dataTable,
              () =>
                !JSON.parse(sessionStorage.getItem("user")).groups.some(
                  (role) => role.name === COORDINADOR_DOCENTE,
                ),
              ["actions"],
            )}
            canSearch
            paginationApi
            countTotal={countTotal}
            next={next}
            previous={previous}
            handleNext={handleNext}
            handlePrevious={handlePrevious}
            offset={offset}
            setOffset={setOffset}
            setBusqueda={setBusqueda}
            filtersComponent={
              <FiltersComponentContrato
                value={contratoState}
                onChange={handleChangeContrato}
              />
            }
            collapse
            showDetailsOnDoubleClick
            detailsComponent={(rowData) => <RegistroShow rowData={rowData} />}
          />
        )}
      </MDBox>
    </MDBox>
  );
}

DataTableRegistros.propTypes = {
  tableHeader: PropTypes.string.isRequired,
};

export default DataTableRegistros;
